import { createFileRoute, notFound } from '@tanstack/react-router';

import { useBesluitId } from '@/api/queries/besluit';
import { useHoofdstukByLineageId } from '@/api/queries/objects/selectors/useHoofdstukByLineageId';
import { Divider } from '@/components/Divider/Divider';

import { InhoudelijkeOverweging as InhoudelijkeOverwegingView } from './-components/InhoudelijkeOverweging/InhoudelijkeOverweging';
import { ToolbarContentPage } from './-components/ToolbarContentPage/ToolbarContentPage';

/**
 * Route
 */
export const Route = createFileRoute(
  '/$bedrijfLineageId/editor/$besluitId/inhoudelijke-overwegingen/$hoofdstukLineageId'
)({
  loader: async ({
    params: { hoofdstukLineageId, besluitId },
    context: { queryClient },
  }) => {
    const [hoofdstukResponse] = await Promise.all([
      queryClient.ensureQueryData(
        useHoofdstukByLineageId.getOptions(hoofdstukLineageId)
      ),
      queryClient.ensureQueryData(useBesluitId.getOptions(besluitId)),
    ]);

    const hoofdstuk = hoofdstukResponse.objects?.[0];

    if (!hoofdstuk) throw notFound();
  },
  component: InhoudelijkeOverwegingen,
});

/**
 * Route component
 */
function InhoudelijkeOverwegingen() {
  const { hoofdstukLineageId, besluitId } = Route.useParams();

  const hoofdstuk = useHoofdstukByLineageId(hoofdstukLineageId);
  const besluit = useBesluitId(besluitId);

  if (!hoofdstuk.data || !besluit.data) {
    return null;
  }

  return (
    <main className="flex min-h-screen flex-col items-center pt-7">
      <div className="w-full max-w-[112rem] px-6 pb-6 pt-3">
        <div className="px-6 py-1">
          <p className="style-body text-gray-700">{hoofdstuk.data.Nummer}</p>
          <h1
            className="style-h1 text-gray-900"
            dangerouslySetInnerHTML={{ __html: hoofdstuk.data.Titel }}
          />
        </div>

        <Divider className="my-3" />

        <InhoudelijkeOverwegingView
          menuBarClassName="sticky top-7"
          hoofdstuk={hoofdstuk.data}
          besluit={besluit.data}
        />
      </div>

      <ToolbarContentPage besluit={besluit.data} />
    </main>
  );
}
